import { track } from "@amplitude/analytics-browser";
import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { Option } from "@app/shared/components/custom-select/entities/custom-select";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";
import { LandingFacade } from "../../facade/landing.facade";

@Component({
  selector: "app-book-a-demo",
  templateUrl: "./book-a-demo.component.html",
  styleUrls: ["./book-a-demo.component.scss", "../../landing.component.scss"],
})
export class BookADemoComponent implements AfterViewInit {
  constructor(private facade: LandingFacade, private translate: TranslateService) {}

  eraseData$ = this.facade.getEraseData$;

  email: string = "";
  name: string = "";
  phone: string = "";
  businessType: string = undefined;
  orderEstimate: string = undefined;

  orderEstimateOptions: Option[] = [
    {
      key: "< 500",
      label: "< 500",
    },
    {
      key: "500 - 1,000",
      label: "500 - 1,000",
    },
    {
      key: "1,000 - 5,000",
      label: "1,000 - 5,000",
    },
    {
      key: "5,000 - 10,000",
      label: "5,000 - 10,000",
    },
    {
      key: "+ 10,000",
      label: "+ 10,000",
    },
  ];

  @ViewChild('nameInput') nameInput;
  @ViewChild('emailInput') emailInput;
  @ViewChild('phoneInput') phoneInput;
  @ViewChild('businessTypeInput') businessTypeInput;
  @ViewChild('orderEstimateInput') orderEstimateInput;

  ngAfterViewInit(): void {
    this.eraseData$.pipe(
      map(() => {
        this.nameInput.value = null;
        this.phoneInput.value = null;
        this.emailInput.value = null;
      })
    ).subscribe();
  }

  modifyAttribute(att: "email" | "name" | "phone" | "businessType" | "orderEstimate", value) {
    switch (att) {
      case "businessType":
        this.businessType = value;
        break;
      case "email":
        this.email = value;
        break;
      case "name":
        this.name = value;
        break;
      case "orderEstimate":
        this.orderEstimate = value;
        break;
      case "phone":
        this.phone = value;
        break;
      default:
        break;
    }
  }

  sendLead() {
    this.facade.sendLead(this.businessType, this.email, this.name, this.orderEstimate, this.phone);
  }

  sendInfo() {
    const body = {
      email: this.email,
      name: this.name,
      phone: this.phone,
      businessType: this.businessType,
    };
    track("LANDING_SENT_FORM", body);
  }
}
